import React from 'react'
import { AuthProvider, AuthProviderProps } from 'react-oidc-context'
import config from '../../config/config'

interface SSOProviderProps {
  children: React.ReactNode
}

const SSOProvider: React.FC<SSOProviderProps> = ({ children }) => {
  const ssoConfig = config.getSSOConfig()

  const oidcConfig: AuthProviderProps = {
    authority: ssoConfig.authority,
    client_id: ssoConfig.clientId,
    redirect_uri: ssoConfig.redirectUri,
    scope: ssoConfig.scopes.join(' '),
    response_type: ssoConfig.responseType,
    automaticSilentRenew: true,
    loadUserInfo: true,
    onSigninCallback: () => {
      // Clean up URL parameters after successful sign-in
      window.history.replaceState({}, document.title, window.location.pathname)
    }
  }

  return (
    <AuthProvider {...oidcConfig}>
      {children}
    </AuthProvider>
  )
}

export default SSOProvider